module.exports = __webpack_public_path__ + "img/70.283dd619.jpg";